import productsServiceCommon from '../';
import constants from '../../../settings/constants';
import { articleNo } from '../../../util/articleNo';
import { getProppingBounds } from '../models';
import { ITEMS } from '../../../constants';

const articleImages = [];

/**
 * See {@link getFilters} for docs on filters structure.
 * @type {[{filter: (function(*=): function({product: *}): boolean), condition: (function(): boolean), Component: () => JSX.Element}]}
 */
const getFilters = () => [];

function makeArticleImages() {
  const imageList = productsServiceCommon
    .getAll()
    .filter(item => item.modelid)
    .map(product => {
      const { color } = product.filter;
      let articleId = product.id;

      if (!articleNo(articleId)) {
        const includedArticles = productsServiceCommon.getIncludedArticles(
          product.id
        );

        while (includedArticles.length && !articleNo(articleId)) {
          articleId = includedArticles.shift();
        }
      }

      const sceneFileName = `${product.modelid}_${color}_0001.png`;
      const menuFileName = `${product.modelid}_${color}_t_0001.png`;

      const hasPortraitSpecificImage = productsServiceCommon.isType(product, [
        ITEMS.FRAME,
        ITEMS.SHELVING_UNIT,
      ]);

      return {
        name: product.id,
        color: color,
        type: product.filter.type,
        modelid: product.modelid,
        proppingBounds: getProppingBounds(product),
        url: `${constants.IMAGE_ROOT}${sceneFileName}`,
        thumbnailUrl: `${constants.IMAGE_ROOT}thumbnails/${menuFileName}`,
        thumbnailUrlPortrait: hasPortraitSpecificImage
          ? `${constants.IMAGE_ROOT}thumbnails/portrait/${menuFileName}`
          : null,
        thumbnailUrlRTL: `${constants.IMAGE_ROOT}thumbnails/rtl/${menuFileName}`,
      };
    });

  imageList.forEach(image => {
    if (image.proppingBounds && image.proppingBounds.length) {
      for (let i = 1; i <= image.proppingBounds.length; i++) {
        const proppingImage = {
          name: `${image.name}_propping_${i}`,
          url: `${constants.IMAGE_ROOT}${image.modelid}_propping_${i}_${image.color}_0001.png`,
        };
        imageList.push(proppingImage);
      }
    }
  });

  articleImages.push(...imageList);
}

function getArticleImage(id) {
  return articleImages.find(image => image.name === id);
}

function getDragMode(product) {
  return productsServiceCommon.isType(product, ITEMS.TOP_SHELF) ||
    productsServiceCommon.isType(product, ITEMS.BASKET)
    ? constants.DRAG_MODE.INSERT
    : constants.DRAG_MODE.FLOAT;
}

function isBasket(item) {
  return productsServiceCommon.isType(item, ITEMS.BASKET);
}

function isTopShelf(item) {
  return productsServiceCommon.isType(item, ITEMS.TOP_SHELF);
}

function isClothesRail(item) {
  return productsServiceCommon.isType(item, ITEMS.CLOTHES_RAIL);
}
function isCover(item) {
  return productsServiceCommon.isType(item, 'cover');
}

function isStackable(item) {
  return [ITEMS.SHELVING_UNIT, ITEMS.FRAME].indexOf(item.filter.type) !== -1;
}

function getFit(item, slot) {
  // TODO: Make this more generic.
  let fits;
  if (isBasket(item)) {
    fits = productsServiceCommon.getFilteredItems(isBasket, {
      width: slot.width,
      depth: slot.depth,
      variant: slot.variant || item.filter.variant,
    });
  } else if (isTopShelf(item)) {
    fits = productsServiceCommon.getFilteredItems(isTopShelf, {
      width: slot.width,
      depth: slot.depth,
      color: slot.color || item.filter.color,
    });
  } else if (productsServiceCommon.isShelvingUnit(item)) {
    fits = productsServiceCommon.getFilteredItems(
      productsServiceCommon.isShelvingUnit,
      {
        width: slot.width,
        depth: slot.depth,
        color: slot.color || item.filter.color,
      }
    );
  } else if (productsServiceCommon.isLeg(item)) {
    fits = productsServiceCommon.getFilteredItems(productsServiceCommon.isLeg, {
      width: slot.width,
      depth: slot.depth,
      variant: slot.variant || item.filter.variant,
    });
  } else if (isClothesRail(item)) {
    if (slot.partnerSlot) {
      const extRail = productsServiceCommon.getProduct(
        'clothes_rail_50_51_4_white_in'
      );
      const extWidth = slot.partnerSlot.x + slot.partnerSlot.width - slot.x;
      return { ...extRail, width: extWidth, slot: slot };
    }
    return {
      ...productsServiceCommon.getProduct('clothes_rail_50_51_4_white'),
    };
  } else if (isCover(item)) {
    fits = productsServiceCommon.getFilteredItems(isCover, {
      width: slot.width,
      depth: slot.depth,
      height: slot.height || item.height,
      variant: slot.variant || item.filter.variant,
    });
  } else if (productsServiceCommon.isFrame(item)) {
    fits = productsServiceCommon.getFilteredItems(
      productsServiceCommon.isFrame,
      {
        width: slot.width,
        depth: slot.depth,
        height: slot.height || item.height,
        color: slot.color || item.filter.color,
      }
    );
  }

  if (fits && fits.length) {
    return Object.assign({}, fits[0]);
  }
  return null;
}

function isModule(id) {
  // Not implemented for Jonaxel
  return false;
}

function isInsert(id) {
  // Not implemented for Jonaxel
  return false;
}

function isSection(id) {
  // Not implemented for Jonaxel
  return false;
}

function isMultiParentProduct(item) {
  return (
    productsServiceCommon.isType(item, ITEMS.CLOTHES_RAIL) &&
    productsServiceCommon.isExtendable(item)
  );
}

function shouldHaveColorSelector(item) {
  return productsServiceCommon.isType(item, ITEMS.FRAME);
}

export default {
  articleImages,
  getArticleImage,
  getDragMode,
  getFit,
  isAdjustable: isMultiParentProduct,
  isModule,
  isInsert,
  isSection,
  isStackable,
  isMultiParentProduct,
  makeArticleImages,
  shouldHaveColorSelector,
  getFilters,
};
